import { z } from "zod"

export const flightPathPointSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
    altitude: z.number().nullable(),
    heading: z.number().nullable(),
})

export type FlightPathPoint = z.infer<typeof flightPathPointSchema>
